import { render } from "./TransportMain.vue?vue&type=template&id=21056199&scoped=true"
import script from "./TransportMain.vue?vue&type=script&lang=js"
export * from "./TransportMain.vue?vue&type=script&lang=js"

import "./TransportMain.vue?vue&type=style&index=0&id=21056199&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21056199"]])

export default __exports__